import React, { useEffect } from 'react';
import { acciones_uiimh } from '../../json/acciones_uiimh';
import './uiimh.css';
import './main.css';
import './graphic.css';

const Uiimh = () => {
  
   
   useEffect(() => {
     window.scrollTo(0, 0);
   }, []);

  

  return (
    <>
      
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Trabajo.svg")` }}>

            </div>
          </div>
          <div className='secretaria_name'>
            <h1>Objetivo</h1>
          </div>
        </div>


    


        <div className='secretaria_funciones'>
            
            <hr className='hr-gob'/>
            
              <img  className="imagen-mision" src={"../uiihm/objetivo.jpg"}/>
            
            
                           
                
          
      </div>
      
      <div className='secretaria-redes'>
                <a href='https://www.facebook.com/Strabajohgo' target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
                <a href='https://www.instagram.com/strabajohgo/' target="_blank"><i class="fa-brands fa-instagram"></i></a>
                <a href='https://twitter.com/strabajohgo' target="_blank"><i class="fa-brands fa-twitter"></i></a>
              </div>

      </div>
    </>
  )
}

export default Uiimh